
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 .833L0 19.167h20L10 .833zM9.167 7.5h1.666v5.833H9.167V7.5zM10 16.875a1.042 1.042 0 110-2.084 1.042 1.042 0 010 2.084z","fill":"#fff"}})])
          )
        }
      }
    